import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { noop, bindKey } from 'lodash'
import {
  Carousel,
  NextArrow,
  BackArrow,
  ListingCard,
  ListingCardViewModeEnum,
} from '@adc/ui-core'
import _cx from 'classnames/bind'
import cls from './styles.scss'
const cx = _cx.bind(cls)

const nextArrowIconProps = {
  color: 'black',
  size: 'large',
  iconStyle: 'solid',
  className: cx('arrow', 'arrow-shadow'),
}
const backArrowIconProps = {
  color: 'black',
  size: 'large',
  iconStyle: 'solid',
  className: cx('arrow', 'arrow-shadow', 'back-arrow'),
}

export default class ListingCarousel extends Component {
  static propTypes = {
    listings: PropTypes.arrayOf(ListingCard.propTypes.listing),
    analytics: PropTypes.shape({
      next: PropTypes.func,
      back: PropTypes.func,
      save: PropTypes.func,
      click: PropTypes.func,
    }),
    settings: PropTypes.object,
    elmId: PropTypes.string,
    arrowIconPropsSettings: PropTypes.object,
    showSave: PropTypes.bool,
    onSaveToggle: PropTypes.func,
    featureFlags: PropTypes.object,
  }

  static defaultProps = {
    save: noop,
    settings: {},
    arrowIconPropsSettings: {},
  }

  render() {
    const {
      listings,
      analytics,
      settings,
      elmId,
      arrowIconPropsSettings,
      showSave,
      onSaveToggle,
      featureFlags,
    } = this.props
    const defaultAnalytics = {
      next: noop,
      back: noop,
      save: noop,
      click: noop,
      hover: noop,
    }
    const finalAnalytics = Object.assign({}, defaultAnalytics, analytics)
    const finalNextArrowIconProps = Object.assign(
      {},
      nextArrowIconProps,
      arrowIconPropsSettings
    )
    const finalBackArrowIconProps = Object.assign(
      {},
      backArrowIconProps,
      arrowIconPropsSettings
    )
    const carouselSettings = {
      infinite: true,
      slidesToScroll: 1,
      initialSlide: 0,
      variableWidth: true,
      nextArrow: (
        <NextArrow
          next={finalAnalytics.next}
          arrowIconProps={finalNextArrowIconProps}
          alwaysShowArrows
        />
      ),
      prevArrow: (
        <BackArrow
          back={finalAnalytics.back}
          arrowIconProps={finalBackArrowIconProps}
          alwaysShowArrows
        />
      ),
    }
    const finalSettings = Object.assign({}, carouselSettings, settings)

    return (
      <div className={cx('root')}>
        <Carousel
          settings={finalSettings}
          elmId={elmId}
          back={finalAnalytics.back}
          next={finalAnalytics.next}
        >
          {listings.map((listing, i) => (
            <div
              key={`listing_card_${i}`}
              className={cx('u-mr-1', 'u-ml-1', 'u-pb-1')}
              data-target-card-index={`${i}`}
              data-target-id={`${listing.listing_id}`}
              data-target-product-type={`${listing.listing_configuration.product_type}`}
            >
              <ListingCard
                elmId={`${elmId}_listing_card_${i}`}
                listing={listing}
                showSave={showSave}
                onSaveToggle={onSaveToggle}
                viewMode={ListingCardViewModeEnum.GRID}
                linkProps={{
                  href: listing.listing_page_path,
                  onClick: bindKey(finalAnalytics, 'click', i),
                  onMouseLeave: bindKey(finalAnalytics, 'hover', i),
                }}
                featureFlags={featureFlags}
              />
            </div>
          ))}
        </Carousel>
      </div>
    )
  }
}
